export default class BaseStorageProvider {
  getNotes() {
    throw new Error('Method getNotes not implemented');
  }

  getNote() {
    throw new Error('Method getNote not implemented');
  }

  createNote() {
    throw new Error('Method createNote not implemented');
  }

  updateNote() {
    throw new Error('Method updateNote not implemented');
  }

  deleteNote() {
    throw new Error('Method deleteNote not implemented');
  }

  restoreDeletedNotes() {
    throw new Error('Method restoreDeletedNotes not implemented');
  }

  purgeDeletedNotes() {
    throw new Error('Method purgeDeletedNotes not implemented');
  }

  getStagedNotes() {
    throw new Error('Method getStagedNotes not implemented');
  }

  stageNote() {
    throw new Error('Method stageNote not implemented');
  }

  clearStagedNotes() {
    throw new Error('Method clearStagedNotes not implemented');
  }

  deleteStagedNote() {
    throw new Error('Method deleteStagedNote not implemented');
  }

  setNotesRaw() {
    throw new Error('Method setNotesRaw not implemented');
  }

  getNotesRaw() {
    throw new Error('Method getNotesRaw not implemented');
  }

  getTags() {
    throw new Error('Method getTags not implemented');
  }

  getTag() {
    throw new Error('Method getTag not implemented');
  }

  createTag() {
    throw new Error('Method createTag not implemented');
  }

  updateTag() {
    throw new Error('Method updateTag not implemented');
  }

  deleteTag() {
    throw new Error('Method deleteTag not implemented');
  }

  getTagsRaw() {
    throw new Error('Method getTagsRaw not implemented');
  }

  setTagsRaw() {
    throw new Error('Method setTagsRaw not implemented');
  }

  getImages() {
    throw new Error('Method getImages not implemented');
  }

  getImage() {
    throw new Error('Method getImage not implemented');
  }

  createImage() {
    throw new Error('Method createImage not implemented');
  }

  deleteNoteImages() {
    throw new Error('Method deleteNoteImages not implemented');
  }

  deleteImage() {
    throw new Error('Method deleteImage not implemented');
  }

  getImagesRaw() {
    throw new Error('Method getImagesRaw not implemented');
  }

  setImagesRaw() {
    throw new Error('Method setImagesRaw not implemented');
  }
}
